import { useGetUserProfileAPI } from "@/api/userProfile/useUserProfileAPI";
import { CloseIcon, SpinnerIcon } from "@/assets/icons";
import Modal from "@/components/ui/modal";

export const MyProfilePanel = ({
  showMyProfilePanel,
  setShowMyProfilePanel
}: {
  showMyProfilePanel: boolean;
  setShowMyProfilePanel: (params: boolean) => void;
}) => {
  // Since the API call has been cached after login / open the page,
  // we can fetch the user profile data regardless of the panel state.
  const { data: userProfileData, isLoading } = useGetUserProfileAPI();

  return (
    <Modal
      isOpen={showMyProfilePanel}
      onClose={() => setShowMyProfilePanel(false)}
      containerClassname="!static"
    >
      <div className="absolute top-[16px] right-[16px] z-[9] border-gainsboro bg-white rounded-lg w-[456px] h-[calc(100vh-32px)] overflow-y-auto flex flex-col p-6 gap-6">
        <section className="flex items-center justify-between gap-4">
          <h2 className="text-2xl font-semibold text-txtHeading">My Profile</h2>
          <button
            onClick={() => setShowMyProfilePanel(false)}
            className="bg-transparent border-0 p-0"
            aria-label="Close"
            data-testid="my-profile-panel-close-btn"
          >
            <CloseIcon className="fill-dim-gray" />
          </button>
        </section>
        {isLoading ? (
          <section
            className="flex flex-1 items-center justify-center"
            data-testid="my-profile-panel-loading"
          >
            <SpinnerIcon className="spin-animation" width={60} height={60} />
          </section>
        ) : (
          <>
            <section className="flex flex-col gap-4">
              <h3 className="text-base font-semibold text-txtHeading">
                Personal Information
              </h3>
              <div className="flex gap-2 justify-between">
                <p className="text-sm text-txtBody">Full Name</p>
                <p className="text-sm text-txtHeading font-semibold">
                  {userProfileData?.full_name}
                </p>
              </div>
              <div className="flex gap-2 justify-between">
                <p className="text-sm text-txtBody">Email</p>
                <p className="text-sm text-txtHeading font-semibold">
                  {userProfileData?.email_address}
                </p>
              </div>
              <div className="flex gap-2 justify-between">
                <p className="text-sm text-txtBody">Phone Number</p>
                <p className="text-sm text-txtHeading font-semibold">
                  {userProfileData?.phone_number}
                </p>
              </div>
            </section>
            <section className="flex flex-col gap-4">
              <h3 className="text-base font-semibold text-txtHeading">
                Country and Languages
              </h3>
              <div className="flex gap-2 justify-between">
                <p className="text-sm text-txtBody">Time Zone</p>
                <p className="text-sm text-txtHeading font-semibold">
                  {userProfileData?.timezone?.name}
                </p>
              </div>
              <div className="flex gap-2 justify-between">
                <p className="text-sm text-txtBody">Country</p>
                <p className="text-sm text-txtHeading font-semibold">
                  {userProfileData?.country?.name}
                </p>
              </div>
              <div className="flex gap-2 justify-between">
                <p className="text-sm text-txtBody">Language</p>
                <p className="text-sm text-txtHeading font-semibold">
                  {userProfileData?.language?.name}
                </p>
              </div>
              <section className="flex flex-col gap-4">
                <h3 className="text-base font-semibold text-txtHeading">
                  Group
                </h3>
                <div className="flex gap-2 justify-between">
                  <p className="text-sm text-txtBody">Group</p>
                  <p className="text-sm text-txtHeading font-semibold">
                    {userProfileData?.group?.name}
                  </p>
                </div>
              </section>
            </section>
          </>
        )}
      </div>
    </Modal>
  );
};

export default MyProfilePanel;
